import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import {
  FilterableGridModuleState,
  GET_FILTERS_TO_SHOW,
  UPDATE_SORTING,
  UPDATE_OUTER_FILTER,
} from '../FilterableGridModule.store';
import { FilterItem } from '../FilterableGridModule.types';

import Tick from '@/assets/icons/tick-alt.svg?inline';

import Dropdown from '@/components/Dropdown/Dropdown.vue';
import FilteringComponent from './FilteringComponent/FilteringComponent.vue';
import CtaButton from '@/components/CtaButton/CtaButton.vue';
import ExpeditionTeamDisclaimer from '@/modules/TeamExpeditionFinderModule/ExpeditionTeamDisclaimer/ExpeditionTeamDisclaimer.vue';
@Component({
  components: { Dropdown, FilteringComponent, CtaButton, Tick, ExpeditionTeamDisclaimer },
})
export default class FilterableGridHeaderComponent extends mixins(StoreModuleMixin) {
  state!: FilterableGridModuleState;

  @Prop() readonly DisclaimerMessage!: string;
  @Prop() readonly AppliedFilters: string;

  get getFilters(): FilterItem[] {
    return this.getters(GET_FILTERS_TO_SHOW) || [];
  }

  get getPopupFilters() {
    return this.getFilters.filter((f) => !f.IsDropdown && !f.IsSingleCheckbox);
  }

  get dropdownFilter() {
    const filter = this.getFilters.find((f) => f.IsDropdown);
    if (!filter) {
      return null;
    }

    return {
      filter: filter,
      options: filter.Options.map((o) => ({ Title: o.Text, Value: o.Value })),
      placeholder: filter.Options.find((o) => o.Checked)?.Text,
    };
  }

  get singleCheckBoxFilter() {
    const filter = this.getFilters.find((f) => f.IsSingleCheckbox);

    if (!filter) {
      return null;
    }

    return {
      filter: filter,
      isChecked: filter.Options[0].Checked,
      text: filter.Options[0].Text,
    };
  }

  updateSorting: (sortingOption: string) => void = this.getAction(UPDATE_SORTING);
  updateOuterFilter: (OuterFilterParams: string) => void = this.getAction(UPDATE_OUTER_FILTER);

  get header() {
    let header = '';
    if (this.state.Header) {
      header = this.state.Header;
      if (this.state.ShowHeaderCount) {
        header = `(${this.state.Paging.Total}) ${header}`;
      }
    }

    return header;
  }

  get largeTitle() {
    let largeTitle = '';
    if (this.state.TitleLarge) {
      largeTitle = this.state.TitleLarge;
    }

    return largeTitle;
  }

  get sortingOptions() {
    const { Sorting } = this.state;
    if (!Sorting) return [];

    return this.state.Sorting;
  }

  get currentSortingTitle() {
    const { Sorting, CurrentSorting } = this.state;
    if (!Sorting) return '';

    return this.state.Sorting?.find((s) => s.Value === CurrentSorting)?.Title;
  }

  get total() {
    return this.state.Paging.Total;
  }

  headerCtaClick() {
    this.$emit('headerCtaClick');
  }

  get showFilterSortBlock() {
    return (this.getPopupFilters && this.getPopupFilters.length && !this.state.HideFilters) || (this.sortingOptions && this.sortingOptions.length && !this.state.HideSorting)
  }
}
